import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

interface CurrencyRate {
  rate?: number;
}

interface MarketCardProps {
  currencyPairs?: {
    EURUSD?: CurrencyRate;
    GBPUSD?: CurrencyRate;
  };
  lastUpdated?: string;
}

const MarketCard = ({ currencyPairs: { EURUSD, GBPUSD } = {}, lastUpdated = undefined }: MarketCardProps) => {
  const { t, i18n } = useTranslation("market", { keyPrefix: "marketCard" });

  return (
    <div className="card-modern">
      <div className="card-header-modern">
        <div>
          <div className="card-title">
            <i className="fas fa-chart-line mr-2" style={{ opacity: 0.5 }} />
            {t("title")}
          </div>
          <div className="card-subtitle">
            {lastUpdated ? moment(lastUpdated).locale(i18n.language).format("LLL") : "---"}
          </div>
        </div>
      </div>

      <div className="card-body-modern">
        {/* EUR/USD */}
        <div className="currency-pair">
          <div className="pair-info">
            <div className="pair-icon">
              <span style={{ fontWeight: 700 }}>€</span>
            </div>
            <div className="pair-name">EUR / USD</div>
          </div>
          <div className="pair-rate">{EURUSD?.rate ? EURUSD.rate.toFixed(5) : "---"}</div>
        </div>

        {/* GBP/USD */}
        <div className="currency-pair">
          <div className="pair-info">
            <div className="pair-icon">
              <span style={{ fontWeight: 700 }}>£</span>
            </div>
            <div className="pair-name">GBP / USD</div>
          </div>
          <div className="pair-rate">{GBPUSD?.rate ? GBPUSD.rate.toFixed(5) : "---"}</div>
        </div>
      </div>
    </div>
  );
};

export default MarketCard;
